import { ECHARTS_DATASOURCE_METRICS_CONSOLE_DETAILS } from '@/pages/intelligence/utils/constant';
import { DEVICE_DETAIL_DISABLED_MESSAGE } from '@/pages/intelligence/pages/TopCharts/PCGames/_config/constantDownload';
import { DETAILS_STATS_COUNTRIES_COMMON_DOWNLOAD_API, publisherCheckboxList } from './common';

// const DEVICE_DISABLED_MESSAGE = 'This device is not selected in the page filter.';

// ConsoleDetails 页不展示，PC/PC&Console 页新增的 stream_id 字段
const consolePublisherCheckboxList = {
  ...publisherCheckboxList,
  defaultValue: {
    ...publisherCheckboxList.defaultValue,
    steam_id_show: undefined,
  },
  options: publisherCheckboxList?.options?.slice(0, -1),
};

export default {
  'console-stats-countries': {
    apiUrl: DETAILS_STATS_COUNTRIES_COMMON_DOWNLOAD_API,
    bubbleText: '',
    translate: true,
    formList: [
      {
        className: 'dbi-top-companies-source-metric-selector',
        label: 'dbi_label_metrics',
        type: 'cascadeMetricSelector',
        field: 'metrics',
        defaultValue: [['All', 'All']],
        // defaultValue: DATASOURCE_METRICS_VALUE_CONSOLE_DETAILS,
        cascadeOptions: ECHARTS_DATASOURCE_METRICS_CONSOLE_DETAILS,
        ifUseMetricsMap: true,
      },
      consolePublisherCheckboxList,
      {
        label: 'dbi_label_data_calculation',
        type: 'subForm',
        children: [
          {
            label: 'dbi_label_npd_device_settings',
            type: 'checkboxGroup',
            defaultValue: [
              'PlayStation 4',
              'PlayStation 5',
              'Xbox One',
              'Xbox Series X|S',
              'Nintendo Wii U',
              'Nintendo Switch',
            ],
            field: 'download_devices_npd',
            options: [
              {
                value: 'PlayStation 4',
                label: 'PlayStation 4',
                disabled: false,
                disabledmessage: DEVICE_DETAIL_DISABLED_MESSAGE,
              },
              {
                value: 'PlayStation 5',
                label: 'PlayStation 5',
                disabled: false,
                disabledmessage: DEVICE_DETAIL_DISABLED_MESSAGE,
              },
              {
                value: 'Xbox One',
                label: 'Xbox One',
                disabled: false,
                disabledmessage: DEVICE_DETAIL_DISABLED_MESSAGE,
              },
              {
                value: 'Xbox Series X|S',
                label: 'Xbox Series X|S',
                disabled: false,
                disabledmessage: DEVICE_DETAIL_DISABLED_MESSAGE,
              },
              {
                value: 'Nintendo Wii U',
                label: 'Nintendo Wii U',
                disabled: false,
                disabledmessage: DEVICE_DETAIL_DISABLED_MESSAGE,
              },
              {
                value: 'Nintendo Switch',
                label: 'Nintendo Switch',
                disabled: false,
                disabledmessage: DEVICE_DETAIL_DISABLED_MESSAGE,
              },
            ],
          },
          {
            label: 'dbi_label_gsd_device_settings',
            type: 'checkboxGroup',
            defaultValue: [],
            field: 'download_devices_gsd',
            options: [],
          },
          {
            label: 'dbi_label_mscience_device_settings',
            type: 'checkboxGroup',
            defaultValue: ['PlayStation', 'Xbox', 'Nintendo'],
            field: 'download_devices_mscience',
            options: [
              {
                label: 'PlayStation',
                value: 'PlayStation',
                disabled: false,
                disabledmessage: DEVICE_DETAIL_DISABLED_MESSAGE,
              },
              {
                label: 'Xbox',
                value: 'Xbox',
                disabled: false,
                disabledmessage: DEVICE_DETAIL_DISABLED_MESSAGE,
              },
              {
                label: 'Nintendo',
                value: 'Nintendo',
                disabled: false,
                disabledmessage: DEVICE_DETAIL_DISABLED_MESSAGE,
              },
            ],
          },
          // Famitsu is temporarily unavailable in Console detail downloads.
          // {
          //   label: 'dbi_label_famitsu_device_settings',
          //   type: 'checkboxGroup',
          //   defaultValue: ['ps5', 'ps4', 'switch'],
          //   field: 'download_devices_famitsu',
          //   options: [
          //     {
          //       value: 'ps5',
          //       label: 'PS5',
          //       disabled: false,
          //       disabledmessage: DEVICE_DETAIL_DISABLED_MESSAGE,
          //     },
          //     {
          //       value: 'ps4',
          //       label: 'PS4',
          //       disabled: false,
          //       disabledmessage: DEVICE_DETAIL_DISABLED_MESSAGE,
          //     },
          //     {
          //       value: 'switch',
          //       label: 'Switch',
          //       disabled: false,
          //       disabledmessage: DEVICE_DETAIL_DISABLED_MESSAGE,
          //     },
          //   ],
          // },
          {
            label: 'dbi_label_time_settings',
            type: 'radio',
            defaultValue: 'separate',
            field: 'downlaod_date_method',
            // message:
            //   'The metric of Active Users has different granularities, you can get DAU/WAU/MAU when selecting the below options.',
            options: [
              { label: 'dbi_label_aggregated', value: 'aggregated' },
              { label: 'dbi_label_separate_by_time', value: 'separate' },
            ],
          },
          {
            label: 'dbi_label_region_settings',
            type: 'radio',
            field: 'region_method',
            defaultValue: 'aggregated',
            options: [
              { label: 'dbi_label_aggregated', value: 'aggregated' },
              { label: 'dbi_label_separate_by_country', value: 'market' },
              { label: 'dbi_label_separate_by_region', value: 'region' },
            ],
          },
        ],
      },
    ],
  },
  'console-stats-countries-japan-sales': {
    apiUrl: DETAILS_STATS_COUNTRIES_COMMON_DOWNLOAD_API,
    bubbleText: '',
    translate: true,
    formList: [
      {
        className: 'dbi-top-companies-source-metric-selector',
        label: 'dbi_label_metrics',
        type: 'cascadeMetricSelector',
        field: 'metrics',
        defaultValue: [['All', 'All']],
        // defaultValue: DATASOURCE_METRICS_VALUE_CONSOLE_DETAILS,
        cascadeOptions: ECHARTS_DATASOURCE_METRICS_CONSOLE_DETAILS,
        ifUseMetricsMap: true,
      },
      consolePublisherCheckboxList,
      {
        label: 'dbi_label_data_calculation',
        type: 'subForm',
        children: [
          {
            label: 'dbi_label_npd_device_settings',
            type: 'checkboxGroup',
            defaultValue: [
              'PlayStation 4',
              'PlayStation 5',
              'Xbox One',
              'Xbox Series X|S',
              'Nintendo Wii U',
              'Nintendo Switch',
            ],
            field: 'download_devices_npd',
            options: [
              {
                value: 'PlayStation 4',
                label: 'PlayStation 4',
                disabled: false,
                disabledmessage: DEVICE_DETAIL_DISABLED_MESSAGE,
              },
              {
                value: 'PlayStation 5',
                label: 'PlayStation 5',
                disabled: false,
                disabledmessage: DEVICE_DETAIL_DISABLED_MESSAGE,
              },
              {
                value: 'Xbox One',
                label: 'Xbox One',
                disabled: false,
                disabledmessage: DEVICE_DETAIL_DISABLED_MESSAGE,
              },
              {
                value: 'Xbox Series X|S',
                label: 'Xbox Series X|S',
                disabled: false,
                disabledmessage: DEVICE_DETAIL_DISABLED_MESSAGE,
              },
              {
                value: 'Nintendo Wii U',
                label: 'Nintendo Wii U',
                disabled: false,
                disabledmessage: DEVICE_DETAIL_DISABLED_MESSAGE,
              },
              {
                value: 'Nintendo Switch',
                label: 'Nintendo Switch',
                disabled: false,
                disabledmessage: DEVICE_DETAIL_DISABLED_MESSAGE,
              },
            ],
          },
          {
            label: 'dbi_label_gsd_device_settings',
            type: 'checkboxGroup',
            defaultValue: [],
            field: 'download_devices_gsd',
            options: [],
          },
          {
            label: 'dbi_label_mscience_device_settings',
            type: 'checkboxGroup',
            defaultValue: ['PlayStation', 'Xbox', 'Nintendo'],
            field: 'download_devices_mscience',
            options: [
              {
                label: 'PlayStation',
                value: 'PlayStation',
                disabled: false,
                disabledmessage: DEVICE_DETAIL_DISABLED_MESSAGE,
              },
              {
                label: 'Xbox',
                value: 'Xbox',
                disabled: false,
                disabledmessage: DEVICE_DETAIL_DISABLED_MESSAGE,
              },
              {
                label: 'Nintendo',
                value: 'Nintendo',
                disabled: false,
                disabledmessage: DEVICE_DETAIL_DISABLED_MESSAGE,
              },
            ],
          },
          // Famitsu is temporarily unavailable in Console detail downloads.
          // {
          //   label: 'dbi_label_famitsu_device_settings',
          //   type: 'checkboxGroup',
          //   defaultValue: ['ps5', 'ps4', 'switch'],
          //   field: 'download_devices_famitsu',
          //   options: [
          //     {
          //       value: 'ps5',
          //       label: 'PS5',
          //       disabled: false,
          //       disabledmessage: DEVICE_DETAIL_DISABLED_MESSAGE,
          //     },
          //     {
          //       value: 'ps4',
          //       label: 'PS4',
          //       disabled: false,
          //       disabledmessage: DEVICE_DETAIL_DISABLED_MESSAGE,
          //     },
          //     {
          //       value: 'switch',
          //       label: 'Switch',
          //       disabled: false,
          //       disabledmessage: DEVICE_DETAIL_DISABLED_MESSAGE,
          //     },
          //   ],
          // },
          {
            label: 'dbi_label_time_settings',
            type: 'radio',
            defaultValue: 'separate',
            field: 'downlaod_date_method',
            // message:
            //   'The metric of Active Users has different granularities, you can get DAU/WAU/MAU when selecting the below options.',
            options: [
              { label: 'dbi_label_aggregated', value: 'aggregated' },
              { label: 'dbi_label_separate_by_time', value: 'separate' },
            ],
          },
          {
            label: 'dbi_label_region_settings',
            type: 'radio',
            field: 'region_method',
            defaultValue: 'aggregated',
            options: [{ label: 'dbi_label_aggregated', value: 'aggregated' }],
          },
        ],
      },
    ],
  },
  'console-details-store-rank': {
    apiUrl: '/api/v1/intelligence_pc/detail/stats/metrics/store_rank/downloads_excel',
    bubbleText: '',
    translate: true,
    formList: [
      {
        label: 'dbi_label_data_settings',
        type: 'checkboxGroup',
        field: 'source_type',
        defaultValue: ['play_station'],
        options: [
          { label: 'Playstation', value: 'play_station' },
          { label: 'Xbox', value: 'xbox' },
          { label: 'Nintendo', value: 'nintendo' },
        ],
      },
      consolePublisherCheckboxList,
      {
        label: 'dbi_label_data_calculation',
        type: 'subForm',
        children: [
          {
            label: 'dbi_label_time_settings',
            type: 'radio',
            defaultValue: 'separate',
            field: 'date_method',
            options: [{ label: 'dbi_label_separate_by_time', value: 'separate' }],
          },
          {
            label: 'dbi_label_region_settings',
            type: 'radio',
            field: 'region_method',
            defaultValue: 'aggregated',
            options: [
              { label: 'dbi_label_aggregated', value: 'aggregated' },
              { label: 'dbi_label_separate_by_country', value: 'market' },
            ],
          },
        ],
      },
    ],
  },
};
